var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styles from './AuthWithOtherServices.module.scss';
import GoogleAuthLogin from './Google/GoogleAuthLogin';
import Facebook from './Facebook/Facebook';
import QRCodeAuth from './QRCodeAuth/QRCodeAuth';
import { QrCodeButton } from "./QRCodeAuth/QrCodeButton";
var AuthWithOtherServices = function () {
    var _a = useState(false), isQrShow = _a[0], setIsQrShow = _a[1];
    return (
    // <div className={styles.mainContainer}>
    _jsx("div", __assign({ className: styles.otherAuthContainer }, { children: isQrShow ? _jsx(QRCodeAuth, { onQrShow: setIsQrShow }) : (_jsxs("div", __assign({ className: styles.socialNetworksContainer }, { children: [_jsx(GoogleAuthLogin, {}), _jsx(Facebook, {}), _jsx(QrCodeButton, { onQrShow: setIsQrShow })] }))) })));
};
export default AuthWithOtherServices;
